import React, { useEffect, useMemo, useState } from 'react'
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from '../sidebar'
import DemoBanner from '../demo-banner'
import { Wrapper } from './styled'
import { MobileTabBar, MobileTopBar } from './mobile-bars'
import { MobileShellContext } from './mobile-shell'

const Layout = ({ children }) => {
	// Меню на телефоне - отдельный экран «Главная», открывается вкладкой внизу
	const [menuOpen, setMenuOpen] = useState(false)
	const [actionSlot, setActionSlot] = useState(null)
	const [navItems, setNavItems] = useState([])
	const { pathname } = useLocation()

	// Перешли на страницу - меню закрывается
	useEffect(() => {
		setMenuOpen(false)
	}, [pathname])

	const shell = useMemo(() => ({ actionSlot, navItems, setNavItems }), [actionSlot, navItems])

	return (
		<MobileShellContext.Provider value={shell}>
			<Wrapper>
				<MobileTopBar navItems={navItems} actionSlotRef={setActionSlot} />
				<Sidebar open={menuOpen} onNavigate={() => setMenuOpen(false)} />
				<Outlet/>
				{children}
				<MobileTabBar
					navItems={navItems}
					menuOpen={menuOpen}
					onToggleMenu={() => setMenuOpen((open) => !open)}
				/>
				<DemoBanner/>
			</Wrapper>
		</MobileShellContext.Provider>
	)
}

export default Layout
